module.exports = __webpack_public_path__ + "static/media/CL 22.854ca7d4.mp3";